import { useEffect, useState } from 'react'
import { PieChart } from '@mantine/charts'
import './PathologyChart.css'
import SectionTitle from '../SectionTitle/SectionTitle'
import axios from 'axios'
import showNotification from '../../utils/showNotification'
import { Loader } from '@mantine/core'

export default function PathologyChart() {
    const [active, setActive] = useState(null)
    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true)
                const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/pathology-reports?chart=true`);
                setData(data);
            } catch (error) {
                console.error("Error cargando el mapa:", error);
                showNotification({
                    color: "red",
                    status: 'error',
                    title: "Error de conexión",
                    message: "No se pudieron cargar los datos del mapa."
                });
            } finally {
                setIsLoading(false)
            }
        };
        fetchData();
    }, []);

    const isError = !isLoading && !data

    if (isError) return <></>

    const activeItem = (data && active !== null) ? data[active] : null

    return (
        <section className="pchart-section section-wrapper">
            {/* <SectionTitle
                upText="Radar"
                downText="Tendencias en Patologías"
            /> */}

            <div className="pchart-grid">

                {/* ── Left: chart ── */}
                <div className="pchart-chart-col">
                    <div className="pchart-chart-wrapper">
                        {isLoading ? <Loader /> : <PieChart
                            data={data}
                            size={320}
                            withLabels
                            withLabelsLine
                            labelsType="percent"
                            labelsPosition="outside"
                            withTooltip
                            tooltipDataSource="segment"
                            strokeWidth={1}
                            strokeColor="white"
                            valueFormatter={(v) => `${v}%`}
                            pieProps={{
                                activeIndex: active,
                                onMouseEnter: (_, index) => setActive(index),
                                onMouseLeave: () => setActive(null),
                                paddingAngle: 2,
                            }}
                        />}
                    </div>
                </div>

                {/* ── Right: legend + detail ── */}
                <div className="pchart-legend-col">
                    <p className="pchart-desc">
                        Distribución de las patologías más frecuentes reportadas por veterinarios
                        en LATAM. Pasá el cursor sobre cada segmento para ver el detalle.
                    </p>

                    {/* Active detail card */}
                    <div className={`pchart-detail-card${activeItem ? ' pchart-detail-card--visible' : ''}`} style={{
                        background: activeItem ? activeItem.color : "transparent"
                    }}>
                        {activeItem && (
                            <>
                                <div className="pchart-detail-dot" style={{ background: '#fff' }} />
                                <div>
                                    <div className="pchart-detail-name">{activeItem.name}</div>
                                    <div className="pchart-detail-obs">{activeItem.obs}</div>
                                </div>
                                <div className="pchart-detail-pct" >
                                    {activeItem.value}%
                                </div>
                            </>
                        )}
                        {!activeItem && (
                            <span className="pchart-detail-placeholder">
                                Pasá el cursor sobre un segmento
                            </span>
                        )}
                    </div>

                    {/* Legend list */}
                    <div className="pchart-legend">
                        {data && data?.map((item, i) => (
                            <div
                                key={item.name}
                                className={`pchart-legend-item${active === i ? ' pchart-legend-item--active' : ''}`}
                                onMouseEnter={() => setActive(i)}
                                onMouseLeave={() => setActive(null)}
                            >
                                <span className="pchart-legend-dot" style={{ background: item.color }} />
                                <span className="pchart-legend-name">{item.name}</span>
                                <span className="pchart-legend-pct" style={{ color: item.color }}>
                                    {item.value}%
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}